import { WorkflowStepActionKey } from 'dashboard/models/workflow-version';

export const ACTIONS_WITH_CUSTOM_ADVANCED_CONFIG = [
  WorkflowStepActionKey.CreateCase,
  WorkflowStepActionKey.CreateDocumentGovernmentId,
  WorkflowStepActionKey.CreateInquiry,
  WorkflowStepActionKey.CreateSAR,
  WorkflowStepActionKey.EvaluateCode,
  WorkflowStepActionKey.GPTGenerateMessage,
  WorkflowStepActionKey.HttpRequest,
  WorkflowStepActionKey.HubspotOAuthCreateObject,
  WorkflowStepActionKey.HubspotOAuthUpdateObject,
  WorkflowStepActionKey.RedactObject,
  WorkflowStepActionKey.RunReportGeneric,
  WorkflowStepActionKey.RunReportWithParams,
  WorkflowStepActionKey.RunVerificationGeneric,
  WorkflowStepActionKey.SendEmail,
  WorkflowStepActionKey.SendSlackMessage,
  WorkflowStepActionKey.SmsInquiryLink,
  WorkflowStepActionKey.UpdateAccountFromUserInput,
  WorkflowStepActionKey.UpdateAccount,
  WorkflowStepActionKey.UpdateObject,
  WorkflowStepActionKey.ZendeskAddTagsToTicket,
  WorkflowStepActionKey.ZendeskCreateTicket,
  WorkflowStepActionKey.ZendeskOAuthCreateTicket,
  WorkflowStepActionKey.ZendeskOAuthUpdateTicket,
  WorkflowStepActionKey.ZendeskRemoveTagsFromTicket,
  WorkflowStepActionKey.ZendeskUpdateTicket,
];
